import { Component, computed, input, output } from "@angular/core";
import {
  PlanFilterConfig,
  PlanFilterChangeEvent,
  FilterOption,
} from "@bitwarden/web-vault/app/gloss/plugins/plugin-filter/plugin-filter-config.model";

@Component({
  selector: "app-plans-filter",
  templateUrl: "./plans-filter.component.html",
})
export class PlansFilterComponent {
  filterConfig = input<PlanFilterConfig>({
    markets: [],
    features: [],
  });

  showFeatures = true;
  isMobile = input<boolean>(false); // Controls checkbox appearance (shadow and selected state)

  filterChange = output<PlanFilterChangeEvent>();

  markets = computed(() => this.filterConfig().markets);
  features = computed(() => this.filterConfig().features);

  // Compute if all options (markets and features) are selected
  allSelected = computed(() => {
    const allMarketsSelected = this.markets().every((opt) => opt.selected || opt.disabled);
    const allFeaturesSelected = this.showFeatures
      ? this.features().every((opt) => opt.selected || opt.disabled)
      : true;
    return allMarketsSelected && allFeaturesSelected;
  });

  title = computed(() => "bundles");

  onAllChange(checked: boolean): void {
    // Emit change events for both markets and features
    this.filterChange.emit({
      type: "market",
      checked,
      isAllChange: true,
    });

    if (this.showFeatures) {
      this.filterChange.emit({
        type: "features",
        checked,
        isAllChange: true,
      });
    }
  }

  onMarketChange(event: { option: FilterOption; checked: boolean }): void {
    this.filterChange.emit({
      type: "market",
      option: event.option,
      checked: event.checked,
    });
  }

  onFeaturesChange(event: { option: FilterOption; checked: boolean }): void {
    this.filterChange.emit({
      type: "features",
      option: event.option,
      checked: event.checked,
    });
  }

  onAllMarketChange(checked: boolean): void {
    this.filterChange.emit({
      type: "market",
      checked,
      isAllChange: true,
    });
  }

  onAllFeaturesChange(checked: boolean): void {
    this.filterChange.emit({
      type: "features",
      checked,
      isAllChange: true,
    });
  }
}
